import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ListingProductCart from "../../component/ListingProductCart";
import service from "services/service";
import { globalStore } from "stores/globalStore";
import { useNavigate } from "react-router-dom";
import "./ProductListing.css";
import "component/FilterMenu.css";
import SEO from "component/SEO/SEO";

const ProductListingPage = () => {
  const location = useLocation();
  const searchResults = location.state?.searchResults || [];
  const navigate = useNavigate();
  const { setProductListingPageData, productListingPageData } = globalStore();

  const [filterData, setFilterData] = useState({
    colors: [],
    sizes: [],
    categories: [],
    priceRange: { minPrice: 0, maxPrice: 0 },
  });

  const [selectedFilters, setSelectedFilters] = useState({
    colors: [],
    sizes: [],
    categories: [],
    priceRange: [0, 0],
  });

  const [open, setOpen] = useState({});
  const [priceRange, setPriceRange] = useState([0, 0]);

  const fetchFilterData = async () => {
    try {
      const response = await service.getFilterOption();
      setFilterData({
        colors: response.colorNames,
        sizes: response.sizes,
        categories: response.categories,
        priceRange: response.priceRange,
      });
      setPriceRange([
        response.priceRange.minPrice,
        response.priceRange.maxPrice,
      ]);
      setSelectedFilters((prev) => ({
        ...prev,
        priceRange: [
          response.priceRange.minPrice,
          response.priceRange.maxPrice,
        ],
      }));
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  const fetchAllData = async () => {
    try {
      const params = {};
      if (selectedFilters.categories.length > 0) {
        params.category = selectedFilters.categories.join(",");
      }
      if (selectedFilters.sizes.length > 0) {
        params.size = selectedFilters.sizes.join(",");
      }
      if (selectedFilters.colors.length > 0) {
        params.colorNames = selectedFilters.colors.join(",");
      }

      const response = await service.getAllProducts(params);
      setProductListingPageData({
        allProducts: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered products:", error);
    }
  };

  const handleFilterChange = (type, value) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev };
      if (updatedFilters[type].includes(value)) {
        updatedFilters[type] = updatedFilters[type].filter(
          (item) => item !== value
        );
      } else {
        updatedFilters[type] = [...updatedFilters[type], value];
      }
      return updatedFilters;
    });
  };

  const handlePriceChange = (e, index) => {
    const newRange = [...priceRange];
    newRange[index] = parseInt(e.target.value, 10);
    setPriceRange(newRange);
    setSelectedFilters((prev) => ({ ...prev, priceRange: newRange }));
  };

  const toggleDropdown = (key) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Filter products based on the selected price range
  const filteredProducts = (products) => {
    return products.filter((product) => {
      const productPrice = product.discountPrice || product.price;
      return (
        productPrice >= selectedFilters.priceRange[0] &&
        productPrice <= selectedFilters.priceRange[1]
      );
    });
  };

  // Use the data returned from the backend directly
  const productsToDisplay = filteredProducts(
    searchResults.length > 0
      ? searchResults
      : productListingPageData?.allProducts || []
  );

  useEffect(() => {
    fetchFilterData();
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [
    selectedFilters.colors,
    selectedFilters.sizes,
    selectedFilters.categories,
  ]);

  return (
    <>
      <SEO
        title="Shop All Products"
        description="Browse Rekha Collection's full catalogue - saree, kurti, suit, blouse, nighty & more. Best prices in Kolkata with free delivery across West Bengal. Filter by color, size & category. কলকাতার সেরা দামে সব প্রডাক্ট দেখুন।"
        keywords="buy saree online kolkata, kurti online west bengal, fashion shopping kolkata, কলকাতা শাড়ি কিনুন, পশ্চিমবঙ্গ কুর্তি কিনুন"
        url="/productlisting"
      />
      <div className="listing-1">
        <div className="listing__row">
          <div className="filter">
            <div className="filter-menu">
              <div className="filter-header">
                <span className="filter-icon">⚙️</span> <span>Filter</span>
              </div>

              {/* Color Filter */}
              <div
                className={`filter-item ${open["Color"] ? "open" : ""}`}
                onClick={() => toggleDropdown("Color")}
              >
                <div className="Filter_heading">
                  <span>Color</span>
                  <span className="arrow">{open["Color"] ? "▲" : "▼"}</span>
                </div>
                {open["Color"] && (
                  <div className="filter-options">
                    {filterData.colors.map((colorObj, index) => (
                      <label key={index} className="filter-option">
                        <div>
                          <input
                            type="checkbox"
                            value={colorObj.colorName}
                            checked={selectedFilters.colors.includes(
                              colorObj.colorName
                            )}
                            onChange={() =>
                              handleFilterChange("colors", colorObj.colorName)
                            }
                          />
                        </div>
                        {colorObj.colorName}
                        {/* <span className="Color-count"> {colorObj.count}</span> */}
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Size Filter */}
              <div
                className={`filter-item ${open["Size"] ? "open" : ""}`}
                onClick={() => toggleDropdown("Size")}
              >
                <div className="Filter_heading">
                  <span>Size</span>
                  <span className="arrow">{open["Size"] ? "▲" : "▼"}</span>
                </div>
                {open["Size"] && (
                  <div className="filter-options">
                    {filterData.sizes.map((size, index) => (
                      <label key={index} className="filter-option">
                        <div>
                          <input
                            type="checkbox"
                            value={size}
                            checked={selectedFilters.sizes.includes(size)}
                            onChange={() => handleFilterChange("sizes", size)}
                          />
                        </div>
                        {size}
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Categories Filter */}
              <div
                className={`filter-item ${open["Categories"] ? "open" : ""}`}
                onClick={() => toggleDropdown("Categories")}
              >
                <div className="Filter_heading">
                  <span>Categories</span>
                  <span className="arrow">
                    {open["Categories"] ? "▲" : "▼"}
                  </span>
                </div>
                {open["Categories"] && (
                  <div className="filter-options">
                    {filterData.categories.map((category, index) => (
                      <label key={index} className="filter-option">
                        <div>
                          <input
                            type="checkbox"
                            value={category}
                            checked={selectedFilters.categories.includes(
                              category
                            )}
                            onChange={() =>
                              handleFilterChange("categories", category)
                            }
                          />
                        </div>
                        {category}
                      </label>
                    ))}
                  </div>
                )}
              </div>

              {/* Price Range Filter */}
              <div
                className={`filter-item ${open["Price Range"] ? "open" : ""}`}
                onClick={() => toggleDropdown("Price Range")}
              >
                <div className="Filter_heading">
                  <span>Price Range</span>
                  <span className="arrow">
                    {open["Price Range"] ? "▲" : "▼"}
                  </span>
                </div>
                {open["Price Range"] && (
                  <div className="price-range">
                    <input
                      type="range"
                      min={filterData.priceRange.minPrice}
                      max={filterData.priceRange.maxPrice}
                      value={priceRange[0]}
                      onChange={(e) => handlePriceChange(e, 0)}
                    />
                    <input
                      type="range"
                      min={filterData.priceRange.minPrice}
                      max={filterData.priceRange.maxPrice}
                      value={priceRange[1]}
                      onChange={(e) => handlePriceChange(e, 1)}
                    />
                    <div className="price-values">
                      <span>Min: ₹{priceRange[0]}</span>
                      <span>Max: ₹{priceRange[1]}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="listing__grid">
            {productsToDisplay?.map((product, index) => (
              <div
                key={index}
                onClick={() => navigate(`/product/${product._id}`)}
                className="listing_item"
              >
                <ListingProductCart
                  image={product.primaryImage}
                  title={product.name}
                  brand={product.category}
                  price={product.discountPrice}
                  oldPrice={product.price}
                  discount={product.discount}
                  isNewArrival={product.isNew}
                  colour={product.color}
                  productId={product._id}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductListingPage;
